// extracted by mini-css-extract-plugin
export default {"productDescription":"Tea-z","featuredDescription":"Uea-z","description":"Vea-z","more":"Wea-z","descriptionSku":"Xea-z"};